<template>
  <WdsButtonGhost class="client-payment-request-worker-column" @click="openPanel">
    <WdsAvatarLabel :path="avatarPath" truncated sm>
      <template #subText>
        <WdsStack direction-row align-center gap-sm>
          <WdsText primary>
            {{ column.worker.name }}
          </WdsText>

          <WdsTooltip
            v-if="hasActiveStaffingAgency"
            top
            global
            data-test="payment-request-worker-managed-status"
          >
            <div><WdsIcon color="#0E0D12" name="group" weight="thick" :size="12" /></div>

            <template #tooltip-content>
              <WdsStack direction-column gap-sm>
                <WdsStack direction-column>
                  <div v-if="column.hire?.recruiterManagesWorkers">
                    {{ $t('Worker managed by') }}
                  </div>
                  <div v-else>{{ $t('Ongoing ownership period for') }}</div>
                  <div>
                    <strong>{{ column.hire?.recruiter?.name }}</strong>
                  </div>
                </WdsStack>
              </WdsStack>
            </template>
          </WdsTooltip>
        </WdsStack>
      </template>
    </WdsAvatarLabel>
  </WdsButtonGhost>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  WdsAvatarLabel,
  WdsButtonGhost,
  WdsIcon,
  WdsStack,
  WdsText,
  WdsTooltip,
} from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { getAvatarPath } from '@/utils/avatar'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { useTablePanels } from '@/components/GraphqlDataTable/useTablePanels'

const { openWorkerDetailPanel } = useTablePanels()

const PaymentRequestWorkerColumn = graphql(`
  fragment PaymentRequestWorkerColumnClient on PaymentRequest {
    id
    worker {
      id
      name
      avatar
    }
    hire {
      recruiter {
        name
      }
      recruiterOwnershipDays
      recruiterOwnershipDaysLeft
      recruiterManagesWorkers
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestWorkerColumn>
}>()

const column = computed(() => useFragment(PaymentRequestWorkerColumn, props.row))

const avatarPath = computed(() => getAvatarPath(column.value.worker.avatar, column.value.worker.id))

const hasActiveStaffingAgency = computed(() => {
  const {hire} = column.value
  return (
    hire?.recruiterOwnershipDays &&
    hire.recruiterOwnershipDays > 0 &&
    hire?.recruiterOwnershipDaysLeft &&
    hire.recruiterOwnershipDaysLeft > 0
  )
})

const openPanel = () => {
  openWorkerDetailPanel({
    workerAccountId: column.value.worker.id,
    viewerAccountId: currentAccount.globalId,
  })
}
</script>

<style lang="scss" scoped>
.client-payment-request-worker-column {
  text-align: left;
}
</style>
